export class Functions {

  static downloadCSV(filename: string, data: any[], columns: { field: string, header: string }[]) {
    const csvContent = this.convertToCSV(data, columns);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${filename}.csv`;
    link.click();
  }

  private static convertToCSV(data: any[], columns?: { field: string, header: string }[]): string {
    // Recupero i dati da esportare e creo il contenuto del file cella per cella in modo formattato
    if (!data || data.length === 0) return '';

    const separator = ';';

    // se voglio usare dei "nomi in chiaro" invece che le chiavi delle colonne:
    if (columns && columns.length > 0) {
      const headers = columns.map(c => c.header).join(separator);

      const csvRows = data.map(item =>
        columns.map(c => {
          const val = item[c.field] ?? '';
          return `"${String(val).replace(/"/g, '""')}"`;
        }).join(separator)
      );

      return [headers, ...csvRows].join('\n');
    }

    // Altrimenti uso le chiavi (le recupero dalla prima riga di dati)
    const keys = Object.keys(data[0]);
    const header = keys.join(separator);

    const csvRows = data.map(item =>
      keys.map(k => {
        const val = item[k] ?? '';
        return `"${String(val).replace(/"/g, '""')}"`;
      }).join(separator)
    );

    return [header, ...csvRows].join('\n');
  }
}
